import {
  Box,
  Button,
  FiSearch,
  Flex,
  FormProvider,
  Table,
  TableInstance,
  TableWrapper,
  TextField,
  useTheme,
} from '@agrotoken-tech/ui';
import { Pagination } from '@bcba/frontend-utils';
import { useTranslation } from '@bcba/react-hooks';
import React from 'react';
import { useCreditorCropPledge } from './hooks';
import MultiSelectDropdown from '../MultiSelectDropdown/MultiSelectDropdown';
import { useNavigate } from 'react-router-dom';
import { paths } from '../../routes/paths';

export const CreditorCropPledge = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();
  const {
    formMethods,
    tableInstance,
    isLoading,
    data,
    setPage,
    statusOptions,
    selectedStatuses,
    setSelectedStatuses,
    onFiltersReset,
  } = useCreditorCropPledge();

  const navigateToDetail = ({ uuid }: { uuid: string }) => {
    navigate(paths.cropPledgeDetail.replace(':uuid', uuid));
  };

  return (
    <FormProvider {...formMethods}>
      <TableWrapper
        searchComponent={
          <TextField
            name="search"
            leftElement={<FiSearch />}
            placeholder={t('common.table.search.placeholder')}
          />
        }
        quickFilters={
          <Flex gap={4} alignItems={'center'}>
            <MultiSelectDropdown
              options={statusOptions}
              placeholder={t(
                'backoffice.pages.signUpRequests.table.statusFilter.placeholder',
              )}
              selectedOptions={selectedStatuses}
              setSelectedOptions={setSelectedStatuses}
              allText={t('common.table.statusFilter.allText')}
            />
            <Button variant={'linkPrimary'} onClick={onFiltersReset}>
              {t('common.reset')}
            </Button>
          </Flex>
        }
      >
        <Table
          tableInstance={tableInstance as TableInstance<object>}
          isLoading={isLoading}
          emptyStateContent={{
            title: t('common.noResults'),
            description: t('common.table.emptyState'),
          }}
          handleRowClick={navigateToDetail}
        ></Table>
      </TableWrapper>
      <Box my="3">
        <Pagination
          currentPage={data?.paginationData?.currentPage!}
          totalPageCount={data?.paginationData?.totalPages!}
          previousButtonLabel={t('common.previous')}
          nextButtonLabel={t('common.next')}
          onPageChange={setPage}
          theme={theme}
        />
      </Box>
    </FormProvider>
  );
};

export default CreditorCropPledge;
